import React, { useState, useEffect } from "react";
import axios from "axios";
import { FiBell, FiSend, FiUsers, FiCheckCircle, FiXCircle, FiImage, FiLink, FiX, FiUserPlus, FiTrendingUp, FiUserX } from "react-icons/fi";
import { MdDelete } from "react-icons/md";

const getDefaultScheduleTime = () => {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

const PushNotifications = () => {


  const [schedule, setSchedule] = useState({
  hour: "",
  minute: ""
});
  const [loading, setLoading] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);
  const [formData, setFormData] = useState({
    title: "",
    message: "",
    targetAudience: "all", // all, new_users, last_7_days, active, last_7_days_inactive, specific
    userIds: "",
    image: null,
    logo: null,
    targetDestination: "",
    scheduleTime: getDefaultScheduleTime(),
    language: "all", // all or specific language
    gender: "all", // all, male, female
    osType: "all", // all, android, ios
  });
  const [notificationHistory, setNotificationHistory] = useState([]);
  const [stats, setStats] = useState({
    totalSent: 0,
    todaySent: 0,
    pending: 0,
  });


  const audienceOptions = [
  { id: "all", label: "All Users", icon: <FiUsers /> },
  { id: "new", label: "New Users (Last 7 Days)", icon: <FiUserPlus /> },
  { id: "last7days", label: "Last 7 Days Active Users", icon: <FiTrendingUp /> },
  { id: "active", label: "Active Users", icon: <FiCheckCircle /> },
  { id: "specific", label: "Specific Users", icon: <FiUsers /> },
];


  const screenPaths = [
    { value: "", label: "No Destination" },
    { value: "app://home", label: "Home Screen" },
    { value: "app://profile", label: "Profile Screen" },
    { value: "app://settings", label: "Settings Screen" },
    { value: "app://notifications", label: "Notifications Screen" },
    { value: "app://wallet", label: "Wallet Screen" },
    { value: "app://gifts", label: "Gifts Screen" },
    { value: "app://coin-packages", label: "Coin Packages Screen" },
    { value: "app://purchase-history", label: "Purchase History Screen" },
    { value: "app://call-history", label: "Call History Screen" },
  ];

  const languageOptions = [
    { value: "all", label: "All Languages" },
    // { value: "English", label: "English" },
    { value: "Telugu", label: "Telugu" },
    { value: "Hindi", label: "Hindi" },
    { value: "Kannada", label: "Kannada" },
    { value: "Tamil", label: "Tamil" },
    { value: "Malayalam", label: "Malayalam" },
    { value: "Bengali", label: "Bengali" },
     { value: "Marathi", label: "Marathi" },
      { value: "Gujarati", label: "Gujarati" },
      { value: "Oriya", label: "Oriya" },
      { value: "Punjabi", label: "Punjabi" },
      { value: "Bhojpuri", label: "Bhojpuri" },
  ];



  const genderOptions = [
    { value: "all", label: "All" },
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
  ];

  const osTypeOptions = [
    { value: "all", label: "All" },
    { value: "android", label: "Android" },
    { value: "ios", label: "iOS" },
  ];

  useEffect(() => {
    fetchStats();
    fetchNotificationHistory();
      fetchSchedule(); 

  }, []);


  const fetchSchedule = async () => {
  try {
    const res = await axios.get("/api/v2/admin/coinAlertConfig/coin-reminder");

    if (res.data.data) {
      setSchedule({
        hour: res.data.data.hour,
        minute: res.data.data.minute
      });
    }
  } catch (err) {
    console.error("Error fetching schedule", err);
  }
};



const handleScheduleUpdate = async () => {
  try {
    await axios.post("/api/v2/admin/coinAlertConfig/coin-reminder", {
      hour: Number(schedule.hour),
      minute: Number(schedule.minute)
    });

    alert("✅ Schedule updated successfully");
  } catch (err) {
    console.error(err);
    alert("❌ Failed to update schedule");
  }
};

  const handleDelete = async (id) => {
  const confirmDelete = window.confirm("Are you sure you want to delete this notification?");
  if (!confirmDelete) return;

  try {
    const res = await axios.delete(
      `/api/v1/admin/pushnotifications/${id}`
    );

    fetchStats();
    fetchNotificationHistory();
 
  } catch (error) {
    console.error(error);
    alert("Delete failed");
  }
};


  const fetchStats = async () => {
    try {
      // Replace with your actual API endpoint
      const res = await axios.get("/api/v1/admin/pushnotifications/stats");
      setStats(res.data.data);
    } catch (error) {
      console.error("Error fetching stats:", error);
    }
  };

  const fetchNotificationHistory = async () => {
    try {
      // Replace with your actual API endpoint
      const res = await axios.get("/api/v1/admin/pushnotifications");
      setNotificationHistory(res.data.data);
    } catch (error) {
      console.error("Error fetching history:", error);
    }
  };

  const handleChange = (e) => {
    if (e.target.name === "image") {
      const file = e.target.files[0];
      if (file) {
        setFormData({ ...formData, image: file });
        const reader = new FileReader();
        reader.onloadend = () => {
          setImagePreview(reader.result);
        };
        reader.readAsDataURL(file);
      }
    } else if (e.target.name === "logo") {
      const file = e.target.files[0];
      if (file) {
        setFormData({ ...formData, logo: file });
        const reader = new FileReader();
        reader.onloadend = () => {
          setLogoPreview(reader.result);
        };
        reader.readAsDataURL(file);
      }
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  const handleRemoveImage = () => {
    setFormData({ ...formData, image: null });
    setImagePreview(null);
  };
  const handleRemoveLogo = () => {
    setFormData({ ...formData, logo: null });
    setLogoPreview(null);
  };

  const handleSend = async () => {
    if (!formData.title || !formData.message) {
      alert("Please fill in title and message");
      return;
    }
    if (!formData.scheduleTime) {
      alert("Please select a schedule time");
      return;
    }

    setLoading(true);
    try {
      const formDataToSend = new FormData();
      formDataToSend.append("title", formData.title);
      formDataToSend.append("message", formData.message);
      //formDataToSend.append("targetAudience", formData.targetAudience);
      formDataToSend.append("target", formData.targetAudience);


      if (formData.targetAudience === "specific") {
        formDataToSend.append("userIds", JSON.stringify(formData.userIds.split(",").map(id => id.trim())));
      }
      
      if (formData.image) {
        formDataToSend.append("image", formData.image);
      }
      if (formData.logo) {
        formDataToSend.append("logo", formData.logo);
      }
      
      if (formData.targetDestination) {
        formDataToSend.append("targetDestination", formData.targetDestination);
      }
      


if (formData.scheduleTime) {
  formDataToSend.append(
    "scheduledAt",
    new Date(formData.scheduleTime).toISOString()
  );
} else {
  formDataToSend.append(
    "scheduledAt",
    new Date().toISOString() // current time
  );
}



      const filters = {};
if (formData.language !== "all") filters.language = formData.language;
if (formData.gender !== "all") filters.gender = formData.gender;
if (formData.osType !== "all") filters.osType = formData.osType;

formDataToSend.append("filters", JSON.stringify(filters));


     // Replace with your actual API endpoint
      const res = await axios.post("/api/v1/admin/pushnotifications", formDataToSend, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      
      alert("Push notification sent successfully!");
      setFormData({
        title: "",
        message: "",
        targetAudience: "all",
        userIds: "",
        image: null,
        targetDestination: "",
        scheduleTime: getDefaultScheduleTime(),
        language: "all",
        gender: "all",
        osType: "all",
      });
      setImagePreview(null);
      fetchStats();
      fetchNotificationHistory();
    } catch (error) {
      console.error("Error sending notification:", error);
      alert("Failed to send notification. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-extrabold text-[var(--primary-solid)] flex items-center gap-3">
            <FiBell className="text-3xl" />
            Push Notifications
          </h1>
          <p className="text-[var(--black-text)]/70 mt-2">
            Send push notifications to users
          </p>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
          <div className="bg-gradient-to-br from-blue-500/10 to-blue-500/5 border-2 border-blue-500/20 rounded-xl p-6 shadow-lg">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-blue-400 uppercase tracking-wider">
                  Total Sent
                </p>
                <p className="text-3xl font-bold text-blue-400">
                  {stats.totalSent}
                </p>
              </div>
              <div className="text-4xl text-blue-400">
                <FiSend />
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-green-500/10 to-green-500/5 border-2 border-green-500/20 rounded-xl p-6 shadow-lg">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-green-400 uppercase tracking-wider">
                  Today Sent
                </p>
                <p className="text-3xl font-bold text-green-400">
                  {stats.todaySent}
                </p>
              </div>
              <div className="text-4xl text-green-400">
                <FiCheckCircle />
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-orange-500/10 to-orange-500/5 border-2 border-orange-500/20 rounded-xl p-6 shadow-lg">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-orange-400 uppercase tracking-wider">
                  Pending
                </p>
                <p className="text-3xl font-bold text-orange-400">
                  {stats.pending}
                </p>
              </div>
              <div className="text-4xl text-orange-400">
                <FiXCircle />
              </div>
            </div>
          </div>
        </div>

        {/* Target Audience Selection - Tile Cards */}
        <div className="bg-white border-2 border-gray-200 rounded-xl p-6 mb-8">
          <h2 className="text-xl font-bold text-[var(--primary-solid)] mb-4 flex items-center gap-2">
            <FiUsers />
            Select Target Audience
          </h2>
          <p className="text-sm text-[var(--black-text)]/70 mb-4">
            Choose which users should receive this notification
          </p>
          <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-2">
            {audienceOptions.map((audience, index) => {
              const colors = [
                { bg: "bg-gradient-to-br from-blue-500/10 to-blue-500/5 border-blue-500/20", text: "text-blue-400", icon: "text-blue-400" },
                { bg: "bg-gradient-to-br from-green-500/10 to-green-500/5 border-green-500/20", text: "text-green-400", icon: "text-green-400" },
                { bg: "bg-gradient-to-br from-purple-500/10 to-purple-500/5 border-purple-500/20", text: "text-purple-400", icon: "text-purple-400" },
                { bg: "bg-gradient-to-br from-orange-500/10 to-orange-500/5 border-orange-500/20", text: "text-orange-400", icon: "text-orange-400" },
                { bg: "bg-gradient-to-br from-teal-500/10 to-teal-500/5 border-teal-500/20", text: "text-teal-400", icon: "text-teal-400" },
              ];
              const color = colors[index % colors.length];

              return (
                <button
                  key={audience.id}
                  onClick={() => setFormData({ ...formData, targetAudience: audience.id })}
                  className={`p-3 rounded-xl border-2 transition-all duration-200 text-left ${
                    formData.targetAudience === audience.id
                      ? `${color.bg} ${color.text} shadow-lg scale-105`
                      : `bg-white border-gray-200 hover:border-gray-300 hover:shadow-md`
                  }`}
                >
                  <div className="flex items-center justify-between mb-2">
                    <div className={`text-2xl ${formData.targetAudience === audience.id ? color.icon : "text-[var(--primary-solid)]"}`}>
                      {audience.icon}
                    </div>
                    {formData.targetAudience === audience.id && (
                      <span className="px-2 py-0.5 bg-[var(--yellow)] text-black text-xs font-semibold rounded-full shadow-sm">
                        Selected
                      </span>
                    )}
                  </div>
                  <p className={`font-bold text-xs mb-1 ${formData.targetAudience === audience.id ? color.text : "text-[var(--black-text)]"}`}>
                    {audience.label}
                  </p>
                  <p className={`text-xs ${formData.targetAudience === audience.id ? `${color.text} opacity-80` : "text-[var(--black-text)]/60"}`}>
                    Target specific user groups
                  </p>
                </button>
              );
            })}
          </div>

          {formData.targetAudience === "specific" && (
            <div className="mt-4">
              <label className="block text-sm font-medium text-[var(--black-text)] mb-2">
                User IDs (comma-separated)
              </label>
              <input
                type="text"
                name="userIds"
                value={formData.userIds}
                onChange={handleChange}
                placeholder="e.g., 123, 456, 789"
                className="w-full px-4 py-2 border-2 border-gray-200 bg-white text-[var(--black-text)] rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--primary-solid)]/50 focus:border-[var(--primary-solid)]"
              />
            </div>
          )}

          {/* Additional Filters */}
          <div className="mt-6 pt-6 border-t border-gray-200">
            <h3 className="text-lg font-semibold text-[var(--primary-solid)] mb-4">
              Additional Filters
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {/* Language Filter */}
              <div>
                <label className="block text-sm font-medium text-[var(--black-text)] mb-2">
                  Language
                </label>
                <select
                  name="language"
                  value={formData.language}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border-2 border-gray-200 bg-white text-[var(--black-text)] rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--primary-solid)]/50 focus:border-[var(--primary-solid)] appearance-none"
                >
                  {languageOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>

              {/* Gender Filter */}
              <div>
                <label className="block text-sm font-medium text-[var(--black-text)] mb-2">
                  Gender
                </label>
                <select
                  name="gender"
                  value={formData.gender}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border-2 border-gray-200 bg-white text-[var(--black-text)] rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--primary-solid)]/50 focus:border-[var(--primary-solid)] appearance-none"
                >
                  {genderOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>

              {/* OS Type Filter */}
              <div>
                <label className="block text-sm font-medium text-[var(--black-text)] mb-2">
                  OS Type
                </label>
                <select
                  name="osType"
                  value={formData.osType}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border-2 border-gray-200 bg-white text-[var(--black-text)] rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--primary-solid)]/50 focus:border-[var(--primary-solid)] appearance-none"
                >
                  {osTypeOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>

        {/* Send Notification Form */}
        <div className="bg-white border-2 border-gray-200 rounded-xl p-6 mb-8">
          <h2 className="text-xl font-bold text-[var(--primary-solid)] mb-6 flex items-center gap-2">
            <FiSend />
            Send New Notification
          </h2>

          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-[var(--black-text)] mb-2">
                Title
              </label>
              <input
                type="text"
                name="title"
                value={formData.title}
                onChange={handleChange}
                placeholder="Enter notification title"
                className="w-full px-4 py-2 border-2 border-gray-200 bg-white text-[var(--black-text)] rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--primary-solid)]/50 focus:border-[var(--primary-solid)]"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-[var(--black-text)] mb-2">
                Message
              </label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Enter notification message"
                rows="4"
                className="w-full px-4 py-2 border-2 border-gray-200 bg-white text-[var(--black-text)] rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--primary-solid)]/50 focus:border-[var(--primary-solid)]"
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-[var(--black-text)] mb-2">
                  Logo (Mandate)
                </label>
                {logoPreview ? (
                  <div className="relative">
                    <img
                      src={logoPreview}
                      alt="Logo Preview"
                      className="w-full h-32 object-contain rounded-lg border-2 border-gray-200 bg-white"
                    />
                    <button
                      type="button"
                      onClick={handleRemoveLogo}
                      className="absolute top-2 right-2 bg-red-500 text-white p-2 rounded-full hover:bg-red-600 transition"
                    >
                      <FiX />
                    </button>
                  </div>
                ) : (
                  <label className="flex flex-col items-center justify-center w-full h-32 border-2 border-gray-200 border-dashed rounded-lg cursor-pointer hover:bg-gray-50 transition">
                    <div className="flex flex-col items-center justify-center pt-5 pb-6">
                      <FiImage className="text-3xl text-[var(--primary-solid)] mb-2" />
                      <p className="mb-2 text-sm text-[var(--black-text)]">
                        <span className="font-semibold">Click to upload</span> or drag and drop
                      </p>
                      <p className="text-xs text-[color:var(--yellow)/0.7]">PNG, JPG, GIF up to 10MB</p>
                    </div>
                    <input
                      type="file"
                      name="logo"
                      accept="image/*"
                      onChange={handleChange}
                      className="hidden"
                    />
                  </label>
                )}
              </div>
              <div>
                <label className="block text-sm font-medium text-[var(--black-text)] mb-2">
                  Image (Optional)
                </label>
                {imagePreview ? (
                  <div className="relative">
                    <img
                      src={imagePreview}
                      alt="Preview"
                      className="w-full h-48 object-cover rounded-lg border-2 border-gray-200"
                    />
                    <button
                      type="button"
                      onClick={handleRemoveImage}
                      className="absolute top-2 right-2 bg-red-500 text-white p-2 rounded-full hover:bg-red-600 transition"
                    >
                      <FiX />
                    </button>
                  </div>
                ) : (
                  <label className="flex flex-col items-center justify-center w-full h-32 border-2 border-gray-200 border-dashed rounded-lg cursor-pointer hover:bg-gray-50 transition">
                    <div className="flex flex-col items-center justify-center pt-5 pb-6">
                      <FiImage className="text-3xl text-[var(--primary-solid)] mb-2" />
                      <p className="mb-2 text-sm text-[var(--black-text)]">
                        <span className="font-semibold">Click to upload</span> or drag and drop
                      </p>
                      <p className="text-xs text:[color:var(--yellow)/0.7]">PNG, JPG, GIF up to 10MB</p>
                    </div>
                    <input
                      type="file"
                      name="image"
                      accept="image/*"
                      onChange={handleChange}
                      className="hidden"
                    />
                  </label>
                )}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-[var(--black-text)] mb-2">
                Target Destination (Optional)
              </label>
              <div className="relative">
                <FiLink className="absolute left-3 top-3 text-[var(--primary-solid)]" />
                <select
                  name="targetDestination"
                  value={formData.targetDestination}
                  onChange={handleChange}
                  className="w-full pl-10 pr-4 py-2 border-2 border-gray-200 bg-white text-[var(--black-text)] rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--primary-solid)]/50 focus:border-[var(--primary-solid)] appearance-none"
                >
                  {screenPaths.map((path) => (
                    <option key={path.value} value={path.value}>
                      {path.label}
                    </option>
                  ))}
                </select>
              </div>
              <p className="text-xs text-[color:var(--yellow)/0.7] mt-1">
                Screen path where users will be redirected when they tap the notification
              </p>
            </div>

            <div>
              <label className="block text-sm font-medium text-[var(--black-text)] mb-2">
                Schedule Time <span className="text-red-500">*</span>
              </label>
              <input
                type="datetime-local"
                name="scheduleTime"
                value={formData.scheduleTime}
                onChange={handleChange}
                required
                className="w-full px-4 py-2 border-2 border-gray-200 bg-white text-[var(--black-text)] rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--primary-solid)]/50 focus:border-[var(--primary-solid)]"
              />
            </div>

            <button
              onClick={handleSend}
              disabled={loading}
              className="w-full px-6 py-3 bg-[var(--yellow)] text-white rounded-lg font-semibold hover:opacity-90 transition-all disabled:opacity-50 flex items-center justify-center gap-2"
            >
              {loading ? (
                <>
                  <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                  Sending...
                </>
              ) : (
                <>
                  <FiSend />
                  Send Notification
                </>
              )}
            </button>
          </div>
        </div>

        {/* Notification History */}
        <div className="bg-white border-2 border-gray-200 rounded-xl p-6">
          <h2 className="text-xl font-bold text-[var(--primary-solid)] mb-6 flex items-center gap-2">
            <FiUsers />
            Notification History
          </h2>

          {notificationHistory.length === 0 ? (
            <p className="text-center text-[color:var(--yellow)/0.7] py-8">
              No notifications sent yet
            </p>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="bg-[var(--yellow)] text-white text-xs uppercase font-semibold">
                    <th className="py-3 px-4 text-left">Image</th>
                    <th className="py-3 px-4 text-left">Title</th>
                    <th className="py-3 px-4 text-left">Message</th>
                    <th className="py-3 px-4 text-left">Target Audience</th>
                    <th className="py-3 px-4 text-left">Destination</th>
                    <th className="py-3 px-4 text-left">Sent At</th>
                    <th className="py-3 px-4 text-left">Status</th>
                    <th className="py-3 px-4 text-left">Delete</th>
                  </tr>
                </thead>
                <tbody>
                  {notificationHistory.map((notification, index) => (
                    <tr
                      key={index}
                      className="border-t border-gray-200 hover:bg-[var(--primary-solid)] hover:text-white transition"
                    >
                      <td className="py-3 px-4">
                        {notification.image ? (
                          <img
                            src={notification.image}
                            alt="Notification"
                            className="w-16 h-16 object-cover rounded-lg"
                          />
                        ) : (
                          <span className="text-[color:var(--yellow)/0.5]">No Image</span>
                        )}
                      </td>
                      <td className="py-3 px-4 font-medium">{notification.title}</td>
                      <td className="py-3 px-4 max-w-xs truncate">{notification.message}</td>
                    
                      <td className="py-3 px-4">
  {notification.targetAudience === "all" && "All Users"}
  {notification.targetAudience === "new" && "New Users (Last 7 Days)"}
  {notification.targetAudience === "last7days" && "Last 7 Days Active Users"}
  {notification.targetAudience === "active" && "Active Users"}
  {notification.targetAudience === "specific" && "Specific Users"}
</td>
                      <td className="py-3 px-4">
                        {notification.targetDestination ? (
                          <a
                            href={notification.targetDestination}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-500 hover:underline truncate block max-w-xs"
                            onClick={(e) => e.stopPropagation()}
                          >
                            {notification.targetDestination}
                          </a>
                        ) : (
                          <span className="text-[color:var(--yellow)/0.5]">No Destination</span>
                        )}
                      </td>
                         <p className="text-sm text-gray-500 mt-1">
{notification.createdAt}
    </p>
                      <td className="py-3 px-4">
                        <span
                          className={`px-2 py-1 rounded-full text-xs ${
                            notification.status === "sent"
                              ? "bg-green-500 text-white"
                              : "bg-yellow-500 text-white"
                          }`}
                        >
                          {notification.status || "Pending"}
                        </span>
                      </td>
                      <td><button
  onClick={() => handleDelete(notification.id)}
  className="text-2xl text-red-600 px-3 py-1 rounded-md transition"
>
 <MdDelete/>
</button></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>








{/* 🔥 DAILY SCHEDULER CONTROL */}
<div className="bg-white border-2 border-gray-200 rounded-xl p-6 mb-8">
  <h2 className="text-xl font-bold text-[var(--primary-solid)] mb-4">
    ⏰ Coin Reminder Schedule (Daily)
  </h2>

  <p className="text-sm text-gray-500 mb-4">
    Set daily time when coin reminder will be sent automatically
  </p>

  <div className="grid grid-cols-2 gap-4">
    {/* Hour */}
    <div>
      <label className="text-sm font-medium">Hour (0–23)</label>
      <input
        type="number"
        min="0"
        max="23"
        value={schedule.hour}
        onChange={(e) =>
          setSchedule({ ...schedule, hour: e.target.value })
        }
        className="w-full px-4 py-2 border rounded-lg"
      />
    </div>

    {/* Minute */}
    <div>
      <label className="text-sm font-medium">Minute (0–59)</label>
      <input
        type="number"
        min="0"
        max="59"
        value={schedule.minute}
        onChange={(e) =>
          setSchedule({ ...schedule, minute: e.target.value })
        }
        className="w-full px-4 py-2 border rounded-lg"
      />
    </div>
  </div>

  <button
    onClick={handleScheduleUpdate}
    className="mt-4 px-6 py-2 bg-green-500 text-white rounded-lg"
  >
    Save Schedule
  </button>
</div>



    </div>
  );
};

export default PushNotifications;
